import React, { useState } from "react";
import { ProcessWrapper, ProgressBar, ProgressBarIndicator } from "../styled";
import Contact from "../../components/contact/contact";
import Question from "../../components/question";
import { ReactComponent as HandsCoin } from "../../assets/img/svg/confiansa_manosmoneda.svg";
import { ReactComponent as Face } from "../../assets/img/svg/confiansa_feliz.svg";

export default function Health({
  finishProcess,
  setRecommendation,
  startOver,
  setContact,
  setAssuranceUrl,
  contact,
  secondaryStep,
  specificStep,
}) {
  const [step, setStep] = useState(
    secondaryStep !== "null" ? secondaryStep : 1
  );
  const [stage, setStage] = useState(0);

  const nextStep = () => {
    {
      setStep(step + 1);
      setStage(stage + 1);
    }
  };

  const goToStep = (newStep) => {
    setStep(newStep);
  };

  return (
    <ProcessWrapper>
      <ProgressBar>
        <ProgressBarIndicator progressWidth={(100 * (stage + 1)) / 5} />
      </ProgressBar>

      {step === 0 && (
        <Contact
          nextStep={nextStep}
          setContact={setContact}
          contact={contact}
        />
      )}
      {step === 1 && (
        <Question
          goToStep={() => goToStep(0)}
          text="¿Qué tipo de cobertura buscas?"
          icon={<HandsCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            // {
            //   label: "En caso de accidentes",
            //   action: () => {
            //     setStep(2);
            //     setStage(stage + 1);
            //   },
            // },
            {
              label: "Seguro local",
              action: () => {
                setStep(2);
                setStage(stage + 1);
              },
            },
            {
              label: "Seguro completo internacional",
              action: () => {
                setStep(3);
                setStage(stage + 1);
              },
            },
          ]}
        />
      )}
      {step === 2 && (
        <Question
          goToStep={() =>
            secondaryStep !== 0 ? specificStep("family", 1) : goToStep(1)
          }
          text="¿Cuál es la edad de la persona a asegurar?"
          icon={<Face fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Igual o menor a 5 años",
              action: () => {
                setStep(4);
                setStage(stage + 1);
              },
            },
            {
              label: "Entre 6 y 17 años",
              action: () => {
                setRecommendation({
                  title: "Salud 360",
                  phrase1: "¡Te recomendamos Salud 360!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/salud-360/");
                finishProcess();
              },
            },
            {
              label: "Entre 18 y 49 años",
              action: () => {
                setStep(5);
                setStage(stage + 1);
              },
            },
            {
              label: "Entre 50 y 64 años",
              action: () => {
                setStep(7);
                setStage(stage + 1);
              },
            },
            {
              label: "Mayor o igual a 65 años",
              action: () => {
                setRecommendation({
                  title: "Salud Siempre",
                  phrase1: "¡Te recomendamos Salud Siempre!",
                  phrase2: "",
                });
                finishProcess();
              },
            },
          ]}
        />
      )}
      {step === 4 && (
        <Question
          goToStep={() => goToStep(2)}
          text="¿Deseas asegurar únicamente al menor o asegurarlo con su padre/ madre?"
          icon={<HandsCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Solo al menor",
              action: () => {
                setRecommendation({
                  title: "Salud Siempre",
                  phrase1: "¡Te recomendamos Salud Siempre!",
                  phrase2: "",
                });
                finishProcess();
              },
            },
            {
              label: "Padre / madre + menor",
              action: () => {
                setStep(6);
                setStage(stage + 1);
              },
            },
          ]}
        />
      )}
      {step === 6 && (
        <Question
          goToStep={() => goToStep(4)}
          text="¿Cuál es tu presupuesto aproximado?"
          icon={<HandsCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          optionalText="¡La salud es primero!"
          options={[
            {
              label: "Menor a Q800 al mes",
              action: () => {
                setRecommendation({
                  title: "Salud 360",
                  phrase1: "¡Te recomendamos Salud 360!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/salud-360/");
                finishProcess();
              },
            },
            {
              label: "Más de Q800 al mes",
              action: () => {
                setRecommendation({
                  title: "Roblemed",
                  phrase1:
                    "¡Te recomendamos Seguro de Gastos Médicos Roblemed!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/roblemed/");
                finishProcess();
              },
            },
          ]}
        />
      )}
      {step === 5 && (
        <Question
          goToStep={() => goToStep(2)}
          text="¿Cuál es tu presupuesto mensual?"
          icon={<HandsCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          optionalText="¡La salud es primero!"
          options={[
            {
              label: "Menor a Q600 al mes",
              action: () => {
                setRecommendation({
                  title: "Salud 360",
                  phrase1: "¡Te recomendamos Salud 360!",
                  phrase2: "",
                });
                setAssuranceUrl("https://www.saludsiempre.com.gt/#contacts");
                finishProcess();
              },
            },
            {
              label: "Más de Q600 al mes",

              action: () => {
                setRecommendation({
                  title: "Roblemed",
                  phrase1:
                    "¡Te recomendamos Seguro de Gastos Médicos Roblemed!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/roblemed/");
                finishProcess();
              },
            },
          ]}
        />
      )}
      {step === 3 && (
        <Question
          goToStep={() => goToStep(1)}
          text="¿Qué cobertura necesitas?"
          icon={<HandsCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Cobertura en quetzales",
              action: () => {
                setRecommendation({
                  title: "Roblemed",
                  phrase1:
                    "¡Te recomendamos Seguro de Gastos Médicos Roblemed!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/roblemed/");
                finishProcess();
              },
            },
            {
              label: "Cobertura en dólares",
              action: () => {
                setRecommendation({
                  title: "Premium Health Insurance",
                  phrase1:
                    "¡Te recomomendamos el Seguro Premium Health Insurance ! ",
                  phrase2: "",
                });
                setAssuranceUrl("https://www.saludsiempre.com.gt/#contacts");
                finishProcess();
              },
            },
          ]}
        />
      )}
      {step === 7 && (
        <Question
          goToStep={() => goToStep(2)}
          text="¿Cuál es tu presupuesto mensual?"
          icon={<HandsCoin fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          optionalText="¡La salud es primero!"
          options={[
            {
              label: "Menor a Q600 al mes",
              action: () => {
                setRecommendation({
                  title: "Salud Siempre",
                  phrase1: "¡Te recomendamos Salud Siempre!",
                  phrase2: "",
                });
                setAssuranceUrl("https://www.saludsiempre.com.gt/#contacts");
                finishProcess();
              },
            },
            {
              label: "Más de Q600 al mes",

              action: () => {
                setRecommendation({
                  title: "Roblemed",
                  phrase1:
                    "¡Te recomendamos Seguro de Gastos Médicos Roblemed!",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/roblemed/");
                finishProcess();
              },
            },
          ]}
        />
      )}
    </ProcessWrapper>
  );
}
